/*
  Salt & Tide Co: size guard for the main product page.
  1. No size is shown as picked until the shopper taps one (unless the link already names a variant).
  2. Add to cart and express checkout ask the shopper to choose a size first.
  3. If a size was tapped but the theme has not finished switching to it, wait for it before adding.
*/
(function () {
  if (window.__stSizeGuard) return;
  window.__stSizeGuard = true;

  var hasVariantParam = new URL(window.location.href).searchParams.has('variant');
  var chosen = hasVariantParam;
  var chosenVariantId = null;
  var bypass = false;

  function mainPicker() {
    return document.querySelector('variant-picker[data-template-product-match="true"]');
  }

  function sizeFieldsets() {
    var picker = mainPicker();
    if (!picker) return [];
    return Array.prototype.filter.call(picker.querySelectorAll('fieldset'), function (fs) {
      var legend = fs.querySelector('legend');
      var radios = fs.querySelectorAll('input[type="radio"]');
      return legend && /size/i.test(legend.textContent || '') && radios.length > 1;
    });
  }

  function clearSizeSelection() {
    if (chosen) return;
    sizeFieldsets().forEach(function (fs) {
      fs.querySelectorAll('input[type="radio"]').forEach(function (r) {
        r.checked = false;
        r.removeAttribute('checked');
        r.dataset.currentChecked = 'false';
      });
    });
  }

  function showMessage() {
    var fs = sizeFieldsets()[0];
    if (!fs) return;
    var msg = fs.parentNode.querySelector('.st-size-msg');
    if (!msg) {
      msg = document.createElement('p');
      msg.className = 'st-size-msg';
      msg.setAttribute('role', 'alert');
      msg.textContent = 'Please choose your size first';
      fs.insertAdjacentElement('afterend', msg);
    }
    msg.hidden = false;
    fs.scrollIntoView({ behavior: 'smooth', block: 'center' });
  }

  function hideMessage() {
    document.querySelectorAll('.st-size-msg').forEach(function (m) {
      m.hidden = true;
    });
  }

  function currentFormVariantId() {
    var input = document.querySelector('product-form-component input[name="id"]');
    return input ? String(input.value) : null;
  }

  document.addEventListener(
    'change',
    function (e) {
      var t = e.target;
      if (!(t instanceof HTMLInputElement) || t.type !== 'radio') return;
      var fs = t.closest('fieldset');
      if (!fs || sizeFieldsets().indexOf(fs) === -1) return;
      chosen = true;
      chosenVariantId = t.dataset.variantId ? String(t.dataset.variantId) : null;
      hideMessage();
    },
    true
  );

  window.addEventListener(
    'click',
    function (e) {
      if (bypass) return;
      if (!mainPicker() || sizeFieldsets().length === 0) return;
      var target = e.target instanceof Element ? e.target : null;
      if (!target) return;
      if (target.closest('dialog, quick-add-dialog, .quick-add-modal')) return;
      var buyEl = target.closest(
        'button[name="add"], sticky-add-to-cart button, .shopify-payment-button, shopify-accelerated-checkout'
      );
      if (!buyEl) return;

      if (!chosen) {
        e.preventDefault();
        e.stopImmediatePropagation();
        showMessage();
        return;
      }

      // Size tapped, but the theme may still be switching to it. Wait, then add.
      if (chosenVariantId && currentFormVariantId() && currentFormVariantId() !== chosenVariantId) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var started = Date.now();
        var timer = setInterval(function () {
          if (currentFormVariantId() === chosenVariantId || Date.now() - started > 4000) {
            clearInterval(timer);
            bypass = true;
            try {
              buyEl.click();
            } finally {
              bypass = false;
            }
          }
        }, 100);
      }
    },
    true
  );

  var style = document.createElement('style');
  style.textContent =
    '.st-size-msg{margin:8px 0 0;color:#a3341a;font-size:14px;font-weight:600;}' +
    'variant-picker fieldset:not(:has(input:checked)) .variant-option__button-label__pill{visibility:hidden;}';
  document.head.appendChild(style);

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', clearSizeSelection);
  } else {
    clearSizeSelection();
  }
  window.addEventListener('pageshow', clearSizeSelection);
})();
